module.exports = __webpack_public_path__ + "img/jht-icon-30.46262d61.png";